// src/pages/Budget/mockData.js
// Демо-данные и справочники АРМ «Доходы и расходы».
// В промышленном решении справочники и строки приходят с бэкенда
// (схема budget-report — те же таблицы, из которых читает дашборд СЦ).
// Здесь они зафиксированы, чтобы api.js мог работать автономно (как mockData
// в модуле «Здравоохранение»).

/* Разделы отчёта (19 значений). part — часть баланса для цветного чипа:
   inc — доходы (синий), exp — расходы (янтарный), fin — финансирование (серый),
   ref — справочно (сиреневый). Названия из справочника не переводятся ключами
   словаря — берутся по языку из ru/kk. */
export const SECTIONS = [
  { k: 'INC', part: 'inc', ru: 'I. ДОХОДЫ', kk: 'I. КІРІСТЕР' },
  { k: 'EXP', part: 'exp', ru: 'II. ЗАТРАТЫ', kk: 'II. ШЫҒЫНДАР' },
  {
    k: 'NBL',
    part: 'fin',
    ru: 'III. Чистое бюджетное кредитование',
    kk: 'III. Таза бюджеттік кредиттеу',
  },
  { k: 'BC', part: 'fin', ru: '· Бюджетные кредиты', kk: '· Бюджеттік кредиттер' },
  {
    k: 'BCR',
    part: 'fin',
    ru: '· Погашение бюджетных кредитов',
    kk: '· Бюджеттік кредиттерді өтеу',
  },
  {
    k: 'FAS',
    part: 'fin',
    ru: 'IV. Сальдо по операциям с фин. активами',
    kk: 'IV. Қаржы активтерімен операциялар сальдосы',
  },
  {
    k: 'FAP',
    part: 'fin',
    ru: '· Приобретение финансовых активов',
    kk: '· Қаржы активтерін сатып алу',
  },
  {
    k: 'FAI',
    part: 'fin',
    ru: '· Поступления от продажи фин. активов',
    kk: '· Қаржы активтерін сатудан түсімдер',
  },
  {
    k: 'DEF',
    part: 'fin',
    ru: 'V. Дефицит (профицит) бюджета',
    kk: 'V. Бюджет тапшылығы (профициті)',
  },
  {
    k: 'NOD',
    part: 'fin',
    ru: 'VI. Ненефтяной дефицит (профицит)',
    kk: 'VI. Мұнайлық емес тапшылық (профицит)',
  },
  { k: 'FND', part: 'fin', ru: 'VII. Финансирование дефицита', kk: 'VII. Тапшылықты қаржыландыру' },
  { k: 'LNI', part: 'fin', ru: '· Поступление займов', kk: '· Қарыздар түсімі' },
  { k: 'LNR', part: 'fin', ru: '· Погашение займов', kk: '· Қарыздарды өтеу' },
  {
    k: 'USB',
    part: 'fin',
    ru: '· Используемые остатки бюджетных средств',
    kk: '· Пайдаланылатын бюджет қалдықтары',
  },
  {
    k: 'REF',
    part: 'ref',
    ru: 'Справочно: остатки бюджетных средств',
    kk: 'Анықтама: бюджет қаражатының қалдықтары',
  },
  {
    k: 'BAL_B',
    part: 'ref',
    ru: '· Остатки на начало финансового года',
    kk: '· Қаржы жылының басындағы қалдықтар',
  },
  {
    k: 'BAL_T',
    part: 'ref',
    ru: '· Временно привлечённые / отвлечённые остатки',
    kk: '· Уақытша тартылған / бұрылған қалдықтар',
  },
  {
    k: 'BAL_E',
    part: 'ref',
    ru: '· Остатки на конец отчётного периода',
    kk: '· Есепті кезең соңындағы қалдықтар',
  },
  {
    k: 'BAL_X',
    part: 'ref',
    ru: '· в том числе за счёт внешних займов',
    kk: '· соның ішінде сыртқы қарыздар есебінен',
  },
];

/* Виды бюджета (3 значения). region — для сверки при загрузке файла. */
export const BUDGETS = [
  {
    k: '8',
    ru: '8 — Бюджет района (район и его МСУ)',
    kk: '8 — Аудан бюджеті (аудан және ЖӨБ)',
    region: '150900-Жылыойский район (район и его МСУ)',
  },
  {
    k: '3',
    ru: '3 — Районный бюджет',
    kk: '3 — Аудандық бюджет',
    region: '150901-Жылыойский район',
  },
  {
    k: '7',
    ru: '7 — Бюджет МСУ',
    kk: '7 — ЖӨБ бюджеті',
    region: '150900-Жылыойский район (район и его МСУ)',
  },
];

/* Числовые поля строки (колонки 3–10 отчёта). */
export const NUMF = ['ab', 'ub', 'adj', 'pp', 'cp', 'ca', 'ua', 'ex'];

/* Справочные разделы: годовой бюджет и план платежей в отчёте не заполняются
   (блоки 2 и 3 формы скрыты), пустые ячейки пишутся как NULL, не как 0. */
export const REF_SECTIONS = ['REF', 'BAL_B', 'BAL_T', 'BAL_E', 'BAL_X'];
/* Разделы, для которых пустое исполнение допустимо. */
export const NO_EXEC_SECT = ['REF', 'BAL_T', 'BAL_X'];

/* Слагаемые балансовых тождеств (по строкам-итогам разделов). */
export const RES_SECTIONS = ['INC', 'BCR', 'FAI', 'LNI', 'BAL_B', 'BAL_T'];
export const USE_SECTIONS = ['EXP', 'BC', 'FAP', 'LNR', 'BAL_E'];

/* Единый допуск балансовых тождеств — тот же, что в дашборде: 0,001 тыс. ₸.
   В проде приходит из API; здесь отдаётся meta.tolerance. */
export const TOLERANCE = 0.001;

/* Периоды. Создаются сервером при загрузке файла либо при вводе первой строки;
   экрана управления периодами нет. is_partial — признак неполного периода. */
export const PERIODS = [
  { id: 1, budget: '8', date: '2023-12-31', is_partial: false, rows: 876 },
  { id: 2, budget: '8', date: '2024-12-31', is_partial: false, rows: 1020 },
  { id: 3, budget: '8', date: '2025-12-31', is_partial: false, rows: 1002 },
  { id: 4, budget: '8', date: '2026-05-31', is_partial: true, rows: 847 },
  { id: 5, budget: '3', date: '2026-05-31', is_partial: true, rows: 781 },
  { id: 6, budget: '7', date: '2026-05-31', is_partial: true, rows: 157 },
];

/* Демо-строки: реальная выгрузка ИС «Казначейство», бюджет 8, на 31.05.2026 —
   все 19 строк-разделов, категории доходов, функциональные группы расходов и
   пример пары «подпрограмма 000» / «подпрограмма 015». d — уровень (для показа),
   name_missing выводится из name === ''. */
export const ARM_ROWS = [
  {
    sec: 'INC',
    d: 0,
    code: '',
    name: 'I. ДОХОДЫ',
    ab: 337830560.0,
    ub: 337835467.0,
    adj: 337835467.0,
    pp: 65731931.0,
    cp: 0.0,
    ca: 0.0,
    ua: 0.0,
    ex: 64726941.37677,
  },
  {
    sec: 'EXP',
    d: 0,
    code: '',
    name: 'II. ЗАТРАТЫ',
    ab: 337830560.0,
    ub: 348011476.0,
    adj: 348011476.0,
    pp: 75666726.0,
    cp: 112661150.0,
    ca: 93960012.942,
    ua: 23817774.4511,
    ex: 70142238.4909,
  },
  {
    sec: 'NBL',
    d: 0,
    code: '',
    name: 'III. ЧИСТОЕ БЮДЖЕТНОЕ КРЕДИТОВАНИЕ',
    ab: 10920.0,
    ub: 9379.0,
    adj: 9379.0,
    pp: -3983.0,
    cp: null,
    ca: null,
    ua: null,
    ex: -3086.69964,
  },
  {
    sec: 'BC',
    d: 0,
    code: '',
    name: 'Бюджетные кредиты',
    ab: 17300.0,
    ub: 17300.0,
    adj: 17300.0,
    pp: 0.0,
    cp: 0.0,
    ca: 0.0,
    ua: 0.0,
    ex: 0.0,
  },
  {
    sec: 'BCR',
    d: 0,
    code: '',
    name: 'Погашение бюджетных кредитов',
    ab: 6380.0,
    ub: 7921.0,
    adj: 7921.0,
    pp: 3983.0,
    cp: 0.0,
    ca: 0.0,
    ua: 0.0,
    ex: 3086.69964,
  },
  {
    sec: 'FAS',
    d: 0,
    code: '',
    name: 'IV. САЛЬДО ПО ОПЕРАЦИЯМ С ФИНАНСОВЫМИ АКТИВАМИ',
    ab: 0.0,
    ub: 0.0,
    adj: 0.0,
    pp: 0.0,
    cp: null,
    ca: null,
    ua: null,
    ex: -2611.779,
  },
  {
    sec: 'FAP',
    d: 0,
    code: '',
    name: 'Приобретение финансовых активов',
    ab: 0.0,
    ub: 0.0,
    adj: 0.0,
    pp: 0.0,
    cp: 0.0,
    ca: 0.0,
    ua: 0.0,
    ex: 0.0,
  },
  {
    sec: 'FAI',
    d: 0,
    code: '',
    name: 'Поступление от продажи финансовых активов государства',
    ab: 0.0,
    ub: 0.0,
    adj: 0.0,
    pp: 0.0,
    cp: 0.0,
    ca: 0.0,
    ua: 0.0,
    ex: 2611.779,
  },
  {
    sec: 'DEF',
    d: 0,
    code: '',
    name: 'V. ДЕФИЦИТ (ПРОФИЦИТ) БЮДЖЕТА',
    ab: -10920.0,
    ub: -10185388.0,
    adj: -10185388.0,
    pp: -9930812.0,
    cp: null,
    ca: null,
    ua: null,
    ex: -5409598.63549,
  },
  {
    sec: 'NOD',
    d: 0,
    code: '',
    name: 'VI. НЕНЕФТЯНОЙ ДЕФИЦИТ (ПРОФИЦИТ) БЮДЖЕТА',
    ab: -10920.0,
    ub: -10185388.0,
    adj: -10185388.0,
    pp: -9930812.0,
    cp: null,
    ca: null,
    ua: null,
    ex: -5409598.63549,
  },
  {
    sec: 'FND',
    d: 0,
    code: '',
    name: 'VII. ФИНАНСИРОВАНИЕ ДЕФИЦИТА (ИСПОЛЬЗОВАНИЕ ПРОФИЦИТА) БЮДЖЕТА',
    ab: 10920.0,
    ub: 10185388.0,
    adj: 10185388.0,
    pp: 9930812.0,
    cp: null,
    ca: null,
    ua: null,
    ex: 5409598.63549,
  },
  {
    sec: 'LNI',
    d: 0,
    code: '',
    name: 'Поступление займов',
    ab: 17300.0,
    ub: 17300.0,
    adj: 17300.0,
    pp: 0.0,
    cp: 0.0,
    ca: 0.0,
    ua: 0.0,
    ex: 0.0,
  },
  {
    sec: 'LNR',
    d: 0,
    code: '',
    name: 'Погашение займов',
    ab: 6380.0,
    ub: 7921.0,
    adj: 7921.0,
    pp: 4968.0,
    cp: 4968.0,
    ca: 4967.1,
    ua: 0.0,
    ex: 4967.1,
  },
  {
    sec: 'USB',
    d: 0,
    code: '',
    name: 'Используемые остатки бюджетных средств',
    ab: 0.0,
    ub: 10176009.0,
    adj: 10176009.0,
    pp: 9935780.0,
    cp: null,
    ca: null,
    ua: null,
    ex: 5414565.73549,
  },
  {
    sec: 'REF',
    d: 0,
    code: '',
    name: 'Справочно:                    Остатки бюджетных средств',
    ab: null,
    ub: null,
    adj: null,
    pp: null,
    cp: null,
    ca: null,
    ua: null,
    ex: null,
  },
  {
    sec: 'BAL_B',
    d: 0,
    code: '',
    name: 'Остатки бюджетных средств на начало финансового года',
    ab: null,
    ub: null,
    adj: null,
    pp: null,
    cp: null,
    ca: null,
    ua: null,
    ex: 10176011.68596,
  },
  {
    sec: 'BAL_T',
    d: 0,
    code: '',
    name: 'Временно привлечённые/ отвлечённые остатки бюджетных денег',
    ab: null,
    ub: null,
    adj: null,
    pp: null,
    cp: null,
    ca: null,
    ua: null,
    ex: null,
  },
  {
    sec: 'BAL_E',
    d: 0,
    code: '',
    name: 'Остатки бюджетных средств на конец отчётного периода',
    ab: null,
    ub: null,
    adj: null,
    pp: null,
    cp: null,
    ca: null,
    ua: null,
    ex: 4761445.95047,
  },
  {
    sec: 'BAL_X',
    d: 0,
    code: '',
    name: 'в том числе за счёт внешних займов',
    ab: null,
    ub: null,
    adj: null,
    pp: null,
    cp: null,
    ca: null,
    ua: null,
    ex: null,
  },
  {
    sec: 'INC',
    d: 1,
    code: '1',
    name: 'Налоговые поступления',
    ab: 329410606.0,
    ub: 329410615.0,
    adj: 329410615.0,
    pp: 63343027.0,
    cp: 0.0,
    ca: 0.0,
    ua: 0.0,
    ex: 62313428.71445,
  },
  {
    sec: 'INC',
    d: 2,
    code: '1.01',
    name: 'Подоходный налог',
    ab: 8451600.0,
    ub: 8451600.0,
    adj: 8451600.0,
    pp: 3585381.0,
    cp: 0.0,
    ca: 0.0,
    ua: 0.0,
    ex: 3817831.22072,
  },
  {
    sec: 'INC',
    d: 2,
    code: '1.04',
    name: 'Налоги на собственность',
    ab: 320708256.0,
    ub: 320708265.0,
    adj: 320708265.0,
    pp: 59648199.0,
    cp: 0.0,
    ca: 0.0,
    ua: 0.0,
    ex: 58372747.51759,
  },
  {
    sec: 'INC',
    d: 2,
    code: '1.05',
    name: 'Внутренние налоги на товары, работы и услуги',
    ab: 135750.0,
    ub: 135750.0,
    adj: 135750.0,
    pp: 68109.0,
    cp: 0.0,
    ca: 0.0,
    ua: 0.0,
    ex: 79413.31268,
  },
  {
    sec: 'INC',
    d: 2,
    code: '1.07',
    name: 'Прочие налоги',
    ab: 0.0,
    ub: 0.0,
    adj: 0.0,
    pp: 0.0,
    cp: 0.0,
    ca: 0.0,
    ua: 0.0,
    ex: 0.32745,
  },
  {
    sec: 'INC',
    d: 2,
    code: '1.08',
    name: 'Обязательные платежи, взимаемые за совершение юридически значимых действий',
    ab: 115000.0,
    ub: 115000.0,
    adj: 115000.0,
    pp: 41338.0,
    cp: 0.0,
    ca: 0.0,
    ua: 0.0,
    ex: 43436.33601,
  },
  {
    sec: 'INC',
    d: 1,
    code: '2',
    name: 'Неналоговые поступления',
    ab: 70900.0,
    ub: 70900.0,
    adj: 70900.0,
    pp: 53703.0,
    cp: 0.0,
    ca: 0.0,
    ua: 0.0,
    ex: 58235.83202,
  },
  {
    sec: 'INC',
    d: 2,
    code: '2.01',
    name: 'Доходы от государственной собственности',
    ab: 30800.0,
    ub: 30800.0,
    adj: 30800.0,
    pp: 17078.0,
    cp: 0.0,
    ca: 0.0,
    ua: 0.0,
    ex: 18429.7028,
  },
  {
    sec: 'INC',
    d: 2,
    code: '2.06',
    name: 'Прочие неналоговые поступления',
    ab: 40100.0,
    ub: 40100.0,
    adj: 40100.0,
    pp: 36625.0,
    cp: 0.0,
    ca: 0.0,
    ua: 0.0,
    ex: 39243.43848,
  },
  {
    sec: 'INC',
    d: 1,
    code: '3',
    name: 'Поступления от продажи основного капитала',
    ab: 137800.0,
    ub: 137800.0,
    adj: 137800.0,
    pp: 31384.0,
    cp: 0.0,
    ca: 0.0,
    ua: 0.0,
    ex: 51459.8303,
  },
  {
    sec: 'INC',
    d: 2,
    code: '3.03',
    name: 'Продажа земли и нематериальных активов',
    ab: 137800.0,
    ub: 137800.0,
    adj: 137800.0,
    pp: 31384.0,
    cp: 0.0,
    ca: 0.0,
    ua: 0.0,
    ex: 42026.2293,
  },
  {
    sec: 'INC',
    d: 1,
    code: '5',
    name: 'Поступления трансфертов',
    ab: 8211254.0,
    ub: 8216152.0,
    adj: 8216152.0,
    pp: 2303817.0,
    cp: 0.0,
    ca: 0.0,
    ua: 0.0,
    ex: 2303817.0,
  },
  {
    sec: 'INC',
    d: 2,
    code: '5.02',
    name: 'Трансферты из вышестоящих органов государственного управления',
    ab: 8211254.0,
    ub: 8216152.0,
    adj: 8216152.0,
    pp: 2303817.0,
    cp: 0.0,
    ca: 0.0,
    ua: 0.0,
    ex: 2303817.0,
  },
  {
    sec: 'EXP',
    d: 1,
    code: '01',
    name: 'Государственные услуги общего характера',
    ab: 2067306.0,
    ub: 2646164.0,
    adj: 2646164.0,
    pp: 965681.0,
    cp: 2183251.0,
    ca: 1537457.54056,
    ua: 632336.13901,
    ex: 905121.40155,
  },
  {
    sec: 'EXP',
    d: 2,
    code: '01.01',
    name: 'Представительные, исполнительные и другие органы',
    ab: 1101862.0,
    ub: 1670520.0,
    adj: 1670520.0,
    pp: 519415.0,
    cp: 1241512.0,
    ca: 615872.5751,
    ua: 112184.23141,
    ex: 503688.34369,
  },
  {
    sec: 'EXP',
    d: 3,
    code: '01.01.112',
    name: 'Аппарат маслихата района (города областного значения)',
    ab: 55442.0,
    ub: 62046.0,
    adj: 62046.0,
    pp: 27678.0,
    cp: 32497.0,
    ca: 29557.94018,
    ua: 2191.47998,
    ex: 27366.4602,
  },
  {
    sec: 'EXP',
    d: 4,
    code: '01.01.112.001',
    name: 'Услуги по обеспечению деятельности маслихата района',
    ab: 55442.0,
    ub: 61064.0,
    adj: 61064.0,
    pp: 27678.0,
    cp: 31515.0,
    ca: 28939.94018,
    ua: 1573.47998,
    ex: 27366.4602,
  },
  {
    sec: 'EXP',
    d: 5,
    code: '01.01.112.001.000',
    name: '',
    ab: 55442.0,
    ub: 61064.0,
    adj: 0.0,
    pp: 0.0,
    cp: 0.0,
    ca: 0.0,
    ua: 0.0,
    ex: 0.0,
  },
  {
    sec: 'EXP',
    d: 5,
    code: '01.01.112.001.015',
    name: 'За счёт средств местного бюджета',
    ab: 0.0,
    ub: 0.0,
    adj: 61064.0,
    pp: 27678.0,
    cp: 31515.0,
    ca: 28939.94018,
    ua: 1573.47998,
    ex: 27366.4602,
  },
  {
    sec: 'EXP',
    d: 1,
    code: '07',
    name: 'Жилищно-коммунальное хозяйство',
    ab: 12477253.0,
    ub: 17525183.0,
    adj: 17664378.0,
    pp: 4715462.0,
    cp: 16456968.0,
    ca: 5710710.88339,
    ua: 2708581.22282,
    ex: 3002129.66057,
  },
  {
    sec: 'EXP',
    d: 1,
    code: '15',
    name: 'Трансферты',
    ab: 282174564.0,
    ub: 282174810.0,
    adj: 282174810.0,
    pp: 56000246.0,
    cp: 56000246.0,
    ca: 56000245.06572,
    ua: 0.0,
    ex: 56000245.06572,
  },
];
